import { AdminPageLayout } from './AdminPageLayout';
export default AdminPageLayout;
